import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import hljs from 'highlight.js/lib/core';
import sql from 'highlight.js/lib/languages/sql';

hljs.registerLanguage('sql', sql);

@Directive({
  selector: '[appHighlight]'
})
export class HighlightDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    hljs.highlightElement(this.el.nativeElement);
  }
}
